import { ClientWrapper } from "./client-wrapper";

export default function ClientsPage() {
  return <ClientWrapper />;
}
